<template>
  <div class="danckuts-title" v-bind:class="{ 'danckuts-title-lg': isLarge }">
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'textTitle',
  props: {
    isLarge: null,
    text: null
  }
}
</script>

<style scoped lang="scss">
.danckuts-title.danckuts-title-lg {
  font-size: 2em;
}

.danckuts-title {
  font-size: 14px;
  margin-left: 10px;
  position: relative;
  text-transform: uppercase;
}

.danckuts-title::before {
  border-top: 1px solid #00adee;
  content: "";
  margin-left: -18px;
  margin-top: -1px;
  position: absolute;
  transform: rotate(-45deg);
  transform-origin: 100% 100%;
  width: 24px;
}

.danckuts-title-lg::before {
  margin-left: -28px;
  margin-top: 7px;
  width: 36px;
}
</style>
